// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-field {
  width: 100%;
  height: 35px;
  border-radius: 5px;
  border-top: 1px;
  border-right: 1px;
  border-bottom: 1px;
  border-left: 1px;
  border-style: solid;
  border-color: #d0d5dd;
  padding-left: 5px;
}

.text-field:focus {
  border-top: 1px;
  border-right: 1px;
  border-bottom: 1px;
  border-left: 1px;
  border-style: solid;
  border-color: purple;
  outline: none;
}

textarea.text-field {
  font-family: Inter, sans-serif;
  line-height: 1.4;
  padding: 8px 12px;
}

textarea.text-field:focus {
  border-color: purple;
  outline: none;
}

.select-element {
  width: 100%;
  height: 35px;
  border-radius: 5px;
  border-top: 1px;
  border-right: 1px;
  border-bottom: 1px;
  border-left: 1px;
  border-style: solid;
  border-color: #d0d5dd;
  padding-left: 5px;
}

.select-element:focus {
  border-top: 1px;
  border-right: 1px;
  border-bottom: 1px;
  border-left: 1px;
  border-style: solid;
  border-color: purple;
  padding-left: 5px;
  outline: none;
}

.text-field-social-media {
  width: 100%;
  height: 35px;
  border-radius: 0px 5px 5px 0px;
  border-top: 1px;
  border-right: 1px;
  border-bottom: 1px;
  border-left: 1px;
  border-style: solid;
  border-color: #d0d5dd;
  padding-left: 5px;
}

.text-field-social-media:focus {
  border-radius: 0px 5px 5px 0px;
  border-top: 1px;
  border-right: 1px;
  border-bottom: 1px;
  border-left: 1px;
  border-style: solid;
  border-color: purple;
  padding-left: 5px;
  outline: none;
}

.text-field-social-media-title {
  border-radius: 5px 0px 0px 5px;
  border-top: 1px;
  border-right: 0px;
  border-bottom: 1px;
  border-left: 1px;
  border-style: solid;
  border-color: #d0d5dd;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 9px;
  font-family: "Inter";
  font-size: small;
}
.text-field-social-media-title:focus {
  outline: none;
}

.field-error {
  background-color: #fadadd;
  border-color: red;
}

.select-tag {
  width: 256px;
  height: 35px;
  border-radius: 5px;
  border-style: solid;
  border-color: lightgray;
  padding-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PeopleComponents/EmployeeForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB","sourcesContent":[".text-field {\n  width: 100%;\n  height: 35px;\n  border-radius: 5px;\n  border-top: 1px;\n  border-right: 1px;\n  border-bottom: 1px;\n  border-left: 1px;\n  border-style: solid;\n  border-color: #d0d5dd;\n  padding-left: 5px;\n}\n\n.text-field:focus {\n  border-top: 1px;\n  border-right: 1px;\n  border-bottom: 1px;\n  border-left: 1px;\n  border-style: solid;\n  border-color: purple;\n  outline: none;\n}\n\ntextarea.text-field {\n  font-family: Inter, sans-serif;\n  line-height: 1.4;\n  padding: 8px 12px;\n}\n\ntextarea.text-field:focus {\n  border-color: purple;\n  outline: none;\n}\n\n.select-element {\n  width: 100%;\n  height: 35px;\n  border-radius: 5px;\n  border-top: 1px;\n  border-right: 1px;\n  border-bottom: 1px;\n  border-left: 1px;\n  border-style: solid;\n  border-color: #d0d5dd;\n  padding-left: 5px;\n}\n\n.select-element:focus {\n  border-top: 1px;\n  border-right: 1px;\n  border-bottom: 1px;\n  border-left: 1px;\n  border-style: solid;\n  border-color: purple;\n  padding-left: 5px;\n  outline: none;\n}\n\n.text-field-social-media {\n  width: 100%;\n  height: 35px;\n  border-radius: 0px 5px 5px 0px;\n  border-top: 1px;\n  border-right: 1px;\n  border-bottom: 1px;\n  border-left: 1px;\n  border-style: solid;\n  border-color: #d0d5dd;\n  padding-left: 5px;\n}\n\n.text-field-social-media:focus {\n  border-radius: 0px 5px 5px 0px;\n  border-top: 1px;\n  border-right: 1px;\n  border-bottom: 1px;\n  border-left: 1px;\n  border-style: solid;\n  border-color: purple;\n  padding-left: 5px;\n  outline: none;\n}\n\n.text-field-social-media-title {\n  border-radius: 5px 0px 0px 5px;\n  border-top: 1px;\n  border-right: 0px;\n  border-bottom: 1px;\n  border-left: 1px;\n  border-style: solid;\n  border-color: #d0d5dd;\n  padding-left: 5px;\n  padding-right: 5px;\n  padding-top: 9px;\n  font-family: \"Inter\";\n  font-size: small;\n}\n.text-field-social-media-title:focus {\n  outline: none;\n}\n\n.field-error {\n  background-color: #fadadd;\n  border-color: red;\n}\n\n.select-tag {\n  width: 256px;\n  height: 35px;\n  border-radius: 5px;\n  border-style: solid;\n  border-color: lightgray;\n  padding-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
